import { render, staticRenderFns } from "./UserCharts.vue?vue&type=template&id=d89da26a&scoped=true"
import script from "./UserCharts.vue?vue&type=script&lang=js"
export * from "./UserCharts.vue?vue&type=script&lang=js"
import style0 from "./UserCharts.vue?vue&type=style&index=0&id=d89da26a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d89da26a",
  null
  
)

export default component.exports